import * as React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { TitleComponent } from '../../components/Title';
import { ObjectOverallRatingContainer } from '../ObjectOverallRatingContainer';
import { getObjectInfo } from '../../selectors/objectInfo';
import * as styles from './DailyrentHeaderContainer.css';

interface IDailyrentHeaderContainerProps {
  className?: string;
}

export const DailyrentHeaderContainer = ({ className }: IDailyrentHeaderContainerProps) => {
  const objectInfo = useSelector(getObjectInfo);
  const { objectName, objectUrl } = objectInfo;

  const objectPrefix = 'Отзывы о ';

  const containerRef = React.useRef(null);

  React.useLayoutEffect(() => {
    if (!containerRef || !containerRef.current) {
      return;
    }

    const observer = new IntersectionObserver(
      ([e]) => e.target.toggleAttribute('data-stuck', e.intersectionRatio < 1),
      { threshold: [1] },
    );

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <header className={cn(className, styles['root'])} ref={containerRef}>
      <div className={styles['content']}>
        <TitleComponent objectLink={objectUrl} objectPrefix={objectPrefix} objectTitle={objectName} />
        <ObjectOverallRatingContainer />
      </div>
    </header>
  );
};
